"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDurations = addDurations;
const array_1 = require("../array");
const string_1 = require("../string");
const durationFormatGreaterThan_1 = require("./durationFormatGreaterThan");
/**
 * Add durations together, combining to the provided format.
 *
 * @param durations
 * @param format
 */
function addDurations(durations, format, round = false) {
    if (!(0, array_1.existsAndNotEmpty)(durations)) {
        return {
            amount: 0,
            format
        };
    }
    // Fast exit conditions
    if (durations.length === 1 && durationFormatGreaterThan_1.DURATION_FORMAT_TO_MS_MULTIPLIER[durations[0].format] === durationFormatGreaterThan_1.DURATION_FORMAT_TO_MS_MULTIPLIER[format]) {
        return { amount: durations[0].amount, format };
    }
    // Ok, now the calculation, create 
    const ref = Date.now();
    // copy it
    let date = ref;
    // The idea here is to convert everything to MS, add it to the date and the subtract it
    // from the ref, then convert it back to the desired units.
    let asMS = 0;
    // Go through each
    durations.forEach((duration) => {
        asMS = asMS + durationFormatGreaterThan_1.DURATION_FORMAT_TO_MS_MULTIPLIER[duration.format] * duration.amount;
    });
    // Add it to the date
    date += asMS;
    // Get the multiplier and divide it!
    let amount = (date - ref) / durationFormatGreaterThan_1.DURATION_FORMAT_TO_MS_MULTIPLIER[format];
    // Optional rounding
    if (round) {
        amount = (0, string_1.toNumber)(amount.toFixed(2));
    }
    return {
        amount,
        format
    };
}
//# sourceMappingURL=addDurations.js.map